import { observer } from 'mobx-react'
import { Link, useLocation } from 'react-router-dom'
import './index.scss'
import { ReactComponent as Plus } from '../../../../assets/about/Vector.svg'
import { ReactComponent as SliderArrow } from '../../../../assets/news/Rectangle 28.svg'
import { useEffect, useState } from 'react'
import classNames from 'classnames'
import GlobalState from '../../../../stores/GlobalState'

const ThingsMenu = observer(({ menu, blocks }: { menu: any; blocks: any }) => {
  const [value, setValue] = useState('')
  const { pathname } = useLocation()

  let lang = GlobalState.currentLocale.lang.includes('En')
    ? '/en'
    : GlobalState.currentLocale.lang.includes('ру')
    ? '/ru'
    : ''

  let page = pathname?.includes('for-you') ? '/for-you/' : '/for-business/'
  if (!menu) return <></>

  let firstMenuItem: any = null

  if (menu.list && menu.list.length) {
    firstMenuItem = menu.list[0]
  }

  return (
    <section
      className={classNames(
        'things-menu',
        // pathname.includes('business') && 'dark-theme',
      )}
    >
      <div className="things-menu__list">
        <div className="things-menu__product">
          <a
            className={classNames(
              'things-menu__item',
              pathname ==
                (GlobalState.currentLocale.lang.includes('En')
                  ? '/en' + firstMenuItem?.link
                  : GlobalState.currentLocale.lang.includes('ру')
                  ? '/ru' + firstMenuItem?.link
                  : firstMenuItem?.link) && 'active',
            )}
            href={
              GlobalState.currentLocale.lang.includes('En')
                ? '/en' + firstMenuItem?.link
                : GlobalState.currentLocale.lang.includes('ру')
                ? '/ru' + firstMenuItem?.link
                : firstMenuItem?.link
            }
          >
            <span> {firstMenuItem?.title}</span>
          </a>
          <ul>
            {blocks.map((b: any, i: number) => (
              <li
                className={classNames(
                  pathname.includes(lang + b.linkblock) && 'current',
                )}
                key={i}
              >
                <span className="marker"></span>{' '}
                <a href={lang  + b.linkblock}>{b.info.catShort}</a>
              </li>
            ))}
          </ul>
        </div>

        {menu?.list?.slice(1, menu?.list?.length).map((m: any, i: number) => (
          <a
            className={classNames(
              'things-menu__item',
              pathname ==
                (GlobalState.currentLocale.lang.includes('En')
                  ? '/en' + m.link
                  : GlobalState.currentLocale.lang.includes('ру')
                  ? '/ru' + m.link
                  : m.link) && 'active',
            )}
            href={
              GlobalState.currentLocale.lang.includes('En')
                ? '/en' + m.link
                : GlobalState.currentLocale.lang.includes('ру')
                ? '/ru' + m.link
                : m.link
            }
            key={i}
          >
            <span>{m.title}</span>
          </a>
        ))}
      </div>
      <div className="things-menu__bottom">
        <div className="things-menu__track">
          <div className="things-menu__track-title">{menu?.trackingTitle}</div>
          <div className="things-menu__input">
            <input
              className="input"
              maxLength={40}
              onChange={(e) => {
                if (e.target.value.includes(' ')) {
                  return
                } else setValue(e.target.value)
              }}
            />
            <div
              className="things-menu__input-but"
              onClick={() => {
                if (value.length) {
                  window.location.href = `${lang}/track/?Tracking_ID=${value}`
                }
              }}
            >
              <SliderArrow />
            </div>
          </div>
        </div>
        <a href={lang + '/offices/'} className="things-menu__departs">
          <Plus /> {menu?.departments}
        </a>
      </div>
    </section>
  )
})

export default ThingsMenu
